import { Box } from "@mui/material";
import decorative1 from "../images/decorative1.png";
import arrow from "../images/Arrow.png";
import { motion } from "framer-motion";

export const HeroDecorativeImage = ({
  decorative1,
}: {
  decorative1: string;
}) => (
  <Box
    component="img"
    src={decorative1}
    alt="Decorative"
    sx={{
      position: "absolute",
      width: "20.08%",
      top: 35,
      left: "67.60%",
    }}
  />
);

export const ServicesDecorativeImages = ({
  decorative2,
}: {
  decorative2: string;
}) => (
  <>
    <Box
      component="img"
      src="https://c.animaapp.com/Ks0Ks8Uw/img/group-1321316006.png"
      alt="Decorative"
      sx={{
        position: "absolute",
        width: "7.54%",
        top: "1651px",
        left: 0,
      }}
    />

    <Box
      component="img"
      src={decorative2}
      alt="Decorative"
      sx={{
        position: "absolute",
        width: "15.12%",
        top: "-750px",
        left: 0,
      }}
    />

    <Box
      component="img"
      src={decorative1}
      alt="Decorative"
      sx={{
        position: "absolute",
        width: "11.79%",
        top: "1163px",
        left: "91.87%",
      }}
    />
  </>
);

export const ScrollArrows = () => (
  <Box sx={{ width: "29px", height: "29px", position: "relative" }}>
    <Box
      component={motion.img}
      src={arrow}
      alt="Arrow down"
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "30px",
      }}
      animate={{ y: [0, 12, 0] }}
      transition={{
        duration: 1.2,
        ease: "easeInOut",
        repeat: Infinity,
      }}
    />
  </Box>
);
